import type { TAxiosError } from '@shared';
import { MUTATIONS_INFO } from '@shared';
import { axiosInstance } from '@shared/lib/axios';
import type { AxiosResponse } from 'axios';
import { useMutation, useQueryClient } from 'react-query';
import type { TUser } from '@entities/user/lib/types';
import type { TUseUploadAvatarPayload, TUseUploadAvatarResponse } from './types';
import { onSuccessAvatarChange } from './utils';
export const fetchUploadAvatar = ({
  dataUrl
}: TUseUploadAvatarPayload, uuid = '') => {
  const dataWithoutMimetype = dataUrl.includes('data:') ? dataUrl.split(',')[1] : dataUrl;
  const dataSize = Buffer.from(dataWithoutMimetype, 'base64').length;
  return axiosInstance.post<TUseUploadAvatarResponse>(MUTATIONS_INFO.uploadAvatar.replace(uuid ? '[uuid]' : '[uuid]/', uuid), {
    base64Content: dataWithoutMimetype,
    contentLength: dataSize
  });
};
export const useUploadAvatar = (uuid?: TUser['id'], onSuccess?: () => void) => {
  const queryClient = useQueryClient();
  return useMutation<AxiosResponse<TUseUploadAvatarResponse>, TAxiosError, TUseUploadAvatarPayload>(payload => fetchUploadAvatar(payload, uuid), {
    onSuccess: responseData => {
      onSuccessAvatarChange({
        responseData,
        queryClient,
        uuid
      });
      onSuccess?.();
    }
  });
};